import { Intent } from '@blueprintjs/core';
import * as _ from 'lodash-es';
import * as React from 'react';

export default class FormHelper<D> {
  static getFieldErrorsList(
    validationError?: ValidationErrors<any> | ListValidationErrors<any> | string[]
  ): string[] {
    if (validationError === undefined) {
      return [];
    }
    if (Array.isArray(validationError)) {
      return validationError;
    }
    return _.flatMap(validationError) as any[];
  }

  /**
   * Shift list error when removing tag from tag input.
   * @param error Field error.
   */
  static shiftListError =
    (error?: ListValidationErrors<any>) =>
    (deletedIndex: number): ListValidationErrors<any> | undefined => {
      if (!error) {
        return error;
      }
      const newError: ListValidationErrors<any> = {};
      Object.keys(error)
        .map((index) => Math.trunc(Number(index)))
        .filter((index) => index !== deletedIndex)
        .forEach((index) => {
          if (index < deletedIndex) {
            newError[index] = error[index];
          } else {
            newError[index - 1] = error[index];
          }
        });
      return newError;
    };

  errors: ValidationErrors<D>;

  constructor(errors: ValidationErrors<D>) {
    this.errors = errors;
  }

  /**
   * Convert Django's ArrayField validation error into DANGER color for tag.
   * @param field Field name
   */
  convertErrorForTag(field: keyof D) {
    return (index: number) => {
      const fieldErrors = this.errors[field];
      // @ts-expect-error FIXME
      if (fieldErrors && Array.isArray(fieldErrors[index])) {
        return { intent: Intent.DANGER };
      }
      return {};
    };
  }

  getIntent(field: keyof D | 'non_field_errors') {
    return this.errors[field] ? Intent.DANGER : Intent.NONE;
  }

  getErrors(field: keyof D | 'non_field_errors') {
    const fieldErrors = FormHelper.getFieldErrorsList(this.errors[field]);
    return {
      intent: this.getIntent(field),
      helperText: fieldErrors.map((e, i) => <div key={`${i}-${e}`}> {e} </div>),
    };
  }
}
